import React from 'react';
import '../Common.css';

const About = () => {
  return (
    <div className="about-container">
      <h2>Facilitate Doctor-Patient Discussions</h2>
      <p>In addition to booking appointments, our platform provides a space for doctors and patients to discuss health concerns. This feature ensures that you can have detailed consultations and follow-ups with your healthcare provider.</p>

      <h2>Key Features</h2>
      <ul>
        <li>Easy appointment scheduling</li>
        <li>Real-time availability of doctors</li>
        <li>Secure and private discussions</li>
        <li>Reminders and notifications</li>
        <li>User-friendly interface</li>
      </ul>

      <p>We are committed to providing a seamless and efficient experience for both doctors and patients. Join us and make your healthcare management easier and more effective.</p>
    </div>
  );
};

export default About;
